import _extends from '/app/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as stepperComponents from '~/components/stepper';
import progressMovil from '~/components/progress-movil';
import ProgressLine from '~/components/dashboard/progress-line';
import { SaveAfiliation, NotAffiliationFinalized } from '~/components/modals';
import { mapState, mapGetters } from 'vuex';

export default {
    layout: 'stepped',
    components: _extends({}, stepperComponents, {
        progressMovil: progressMovil,
        SaveAfiliation: SaveAfiliation,
        NotAffiliationFinalized: NotAffiliationFinalized,
        ProgressLine: ProgressLine
    }),
    props: {
        data: Array
    },
    data: function data() {
        return {
            show: false,
            newItems: "",
            itemHeight: 105,
            height: 310,
            page: 1,
            pageSize: 50,
            loading: false,
            steps: this.step,
            pagination: 0
        };
    },

    computed: {
        isMovil: function isMovil() {
            return this.$vuetify.breakpoint.name == 'md' || this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs';
        }
    },
    methods: {
        updateData: function updateData() {
            var _this = this;

            this.loading = true;
            setTimeout(function () {
                _this.loading = false;
                var value = _this.limit * _this.pagination;
                _this.pagination += 1;
                _this.$store.dispatch('dashboard/table/search', {
                    type: 'Work',
                    limit: 10,
                    paginationNumber: _this.pagination
                });
            }, 5000);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/worked-mobile-table.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/worked-mobile-table.vue
// module chunks = 0 1